<div class="servicio-header">
  <div>
    <h2>Configuración de servicio</h2>
  </div>
  <div class="servicio-filtros">
    <label class="form-label mb-1" for="organismoSelect">Órganos</label>
    <div class="d-flex align-items-center gap-2">
      <select id="organismoSelect" name="organismoSelect" class="form-select form-select-sm"
        [(ngModel)]="selectedOrganismoId" [disabled]="organosLoading || loading">
        <option [ngValue]="null">Todos</option>
        @for (organo of organos; track $index) {
        <option [ngValue]="organo.courtId">
          {{ organo.courtId }} - {{ organo.courtName }}
        </option>
        }

      </select>
      <button class="btn btn-primary btn-sm" (click)="buscarServicios()" [disabled]="loading || organosLoading">
        <i class="fas fa-search"></i>
        Buscar
      </button>
      <button class="btn btn-outline-success btn-sm" (click)="agregarConfiguracion()"
        [disabled]="loading || organosLoading || selectedOrganismoId === null">
        <i class="fas fa-plus"></i>
        Agregar configuracion
      </button>
    </div>
    @if(organosLoading){
    <div class="form-text">Cargando catalogo...</div>
    }
    @if(organosError) {
    <div class="text-danger small">{{ organosError }}</div>
    }
  </div>
</div>

@if(errorMessage){
<div class="alert alert-danger">{{ errorMessage }}</div>
}
@if(successMessage){
<div class="alert alert-success">{{ successMessage }}</div>
}
@if(loading){
<div class="alert alert-info">Cargando servicios...</div>
}
@if(!loading && !servicios.length){
<div class="alert alert-warning">
  No hay servicios para mostrar.
</div>
}



@for( servicio of servicios; track $index) {
<div class="servicio-card">
  <div class="servicio-card__header">
    <div>
      <div class="servicio-title">Organismo: {{ displayOrganismo(servicio) }}</div>
    </div>
    <div class="servicio-actions">
      <button class="btn btn-link btn-sm text-decoration-none" type="button" (click)="toggleCollapse(servicio)">
        <i class="fas"
          [ngClass]="{ 'fa-chevron-down': !isCollapsed(servicio), 'fa-chevron-right': isCollapsed(servicio) }"></i>
        {{ isCollapsed(servicio) ? 'Expandir' : 'Contraer' }}
      </button>
      <button class="btn btn-success btn-sm" (click)="guardar(servicio)"
        [disabled]="savingId === servicio.kIdOperServicio || deletingId === servicio.kIdOperServicio">
        <i class="fas fa-save"></i>
        Guardar
      </button>
      <button class="btn btn-outline-danger btn-sm" (click)="desactivar(servicio)"
        [disabled]="deletingId === servicio.kIdOperServicio || savingId === servicio.kIdOperServicio">
        <i class="fas fa-trash-alt"></i>
        Eliminar
      </button>
    </div>
  </div>

  @if(!isCollapsed(servicio)){
    <div class="table-responsive">
    <table class="table table-sm table-bordered align-middle">
      <thead class="table-light">
        <tr>
          <th>Dia</th>
          <th>Laborable</th>
          <th>Completo</th>
          <th>Hora inicio</th>
          <th>Hora fin</th>
        </tr>
      </thead>
      <tbody>
        @for (dia of servicio.dias; track $index) {
        <tr>
          <td class="fw-bold">{{ dia.Dia }}</td>
          <td class="text-center">
            <input type="checkbox" [checked]="toBoolean(dia.Laborable)"
              (change)="onToggle(dia, 'Laborable', $any($event.target).checked)" />
          </td>
          <td class="text-center">
            <input type="checkbox" [checked]="toBoolean(dia.Completo)"
              (change)="onToggle(dia, 'Completo', $any($event.target).checked)" />
          </td>
          <td>
            <input type="time" step="60" class="form-control form-control-sm" [ngModel]="toTimeInput(dia.HoraInicio)"
              (ngModelChange)="onTimeChange(dia, 'HoraInicio', $event)" />
          </td>
          <td>
            <input type="time" step="60" class="form-control form-control-sm" [ngModel]="toTimeInput(dia.HoraFin)"
              (ngModelChange)="onTimeChange(dia, 'HoraFin', $event)" />
          </td>
        </tr>
        }
      </tbody>
    </table>
  </div>
  }
</div>
}